import { Component, Inject } from '@angular/core';
import { ApplicationStep } from "../nuvei-application-step";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: 'app-nuvei-application-bank',
  templateUrl: './nuvei-application-bank.component.html',
  styleUrls: ['./nuvei-application-bank.component.scss']
})
export class NuveiApplicationBankComponent extends ApplicationStep<'bankInformationForm'> {

    fieldExplanations = [
        { id: 'bankTransit', title: 'Bank Transit', explanation: 'The routing or transit number of your bank, which identifies the financial institution.\nThis is required for processing transactions and fund transfers.' },
        { id: 'bankAccountNumber', title: 'Bank Account Number', explanation: 'The unique account number associated with your business banking account. This is where funds from transactions will be deposited.' },
        { id: 'associatedAddress', title: 'Bank account associated address', explanation: 'The physical address type linked to the provided bank account.\n', bulletPoints: [
                'DBA – The Doing Business As (DBA) address is used.',
                'Legal – The legally registered business address is used.',
                'None – No specific address is associated with the bank account.'
        ]},
    ];

    constructor(
        @Inject(DOCUMENT) protected document: Document
    ) {
        super();
    }
}
